import React, { forwardRef } from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import { Quantity } from 'src/components/atoms/Quantity/Quantity';
import { PriceBreakdownContainer } from 'src/components/molecules/PriceBreakdown/PriceBreakdownContainer';
import { PersonalisationContainer } from 'src/components/organisms/Personalisation/containers/PersonalisationContainer';

export interface ProductOptionsDispatchProps {
  onChangeQuantity: (payload: { quantity: number; valid: boolean }) => void;
  onVisible: () => void;
}

export interface ProductOptionsStateProps {
  inStock: boolean;
  purchasable: boolean;
  quantity: number;
  showPriceBreakdown: boolean;
  showValidationErrors: boolean;
}

type ProductOptionsProps = ProductOptionsDispatchProps & ProductOptionsStateProps;

export const ProductOptions = forwardRef(
  ({
    inStock,
    onChangeQuantity,
    onVisible,
    purchasable,
    quantity,
    showPriceBreakdown,
    showValidationErrors,
  }: ProductOptionsProps) => {
    const productPersonalisationsRef = useImpressionRef<HTMLDivElement>(() => onVisible());

    return (
      <form noValidate>
        {purchasable && (
          <div ref={productPersonalisationsRef}>
            <PersonalisationContainer displayValidation={showValidationErrors} />
          </div>
        )}
        {inStock && (
          <>
            {showPriceBreakdown && <PriceBreakdownContainer />}
            <Quantity
              defaultValue={quantity}
              onChange={(quantity, valid) => {
                onChangeQuantity({ quantity, valid });
              }}
            />
          </>
        )}
      </form>
    );
  },
);
